/**
 * Service pour les opérations sur les quotes
 * Aucune logique métier, uniquement des appels API
 */

import { api, endpoints } from './api.js'

export const quotesService = {
  list: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quotes.list()}?${queryString}` : endpoints.quotes.list()
    return api.get(url)
  },

  detail: (id) => api.get(endpoints.quotes.detail(id)),
  analyseCommercialAdvice: (id) => api.post(endpoints.quotes.commercialAdvice(id), {}),

  triageCounts: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    return api.get(`${endpoints.quotes.triageCounts()}?${queryString}`)
  },

  create: (data) => api.post(endpoints.quotes.create(), data),

  update: (id, data) => api.put(endpoints.quotes.update(id), data),

  delete: (id) => api.delete(endpoints.quotes.delete(id)),

  assign: (id, userId) => api.patch(endpoints.quotes.assign(id), { userId }),

  updateStatus: (id, status) => api.patch(endpoints.quotes.status(id), { status }),

  getHistory: (id) => api.get(endpoints.quotes.history(id)),

  getLinkedCompanies: (id) => api.get(endpoints.quotes.linkedCompanies(id)),
  findSimilarCompaniesAi: (id) => api.post(endpoints.quotes.similarCompaniesAi(id)),

  getDuplicates: (id) => api.get(endpoints.quotes.duplicates(id)),

  getUnpaidHistory: (id) => api.get(endpoints.quotes.unpaidHistory(id)),

  getDocuments: (id) => api.get(endpoints.quotes.documents(id)),

  uploadDocument: (id, formData) => api.post(endpoints.quotes.documents(id), formData),

  downloadDocument: (id, docId) => api.get(endpoints.quotes.downloadDocument(id, docId)),

  deleteDocument: (id, docId) => api.delete(endpoints.quotes.downloadDocument(id, docId).replace('/download', '')),

  sendAvailabilityRequest: (id, data) => api.post(endpoints.quotes.sendAvailabilityRequest(id), data),

  proposePhoneAppointment: (id, data) => api.post(endpoints.quotes.proposePhoneAppointment(id), data),

  markNotInterested: (id, data) => api.post(endpoints.quotes.markNotInterested(id), data),

  scheduleRelance: (id, data) => api.post(endpoints.quotes.scheduleRelance(id), data),
  claimForCall: (id) => api.post(endpoints.quotes.callAssignment(id)),
  releaseCallClaim: (id) => api.delete(endpoints.quotes.callAssignment(id)),

  searchClients: (query, userId) => {
    const params = new URLSearchParams({ q: query })
    if (userId) params.append('userId', userId)
    return api.get(`${endpoints.quotes.searchClients()}?${params.toString()}`)
  },

  searchForAppointment: (query) => {
    return api.get(`${endpoints.quotes.searchForAppointment()}?q=${encodeURIComponent(query)}`)
  },

  /** Poser ou effacer la prochaine action d'une demande. */
  updateNextAction: (id, data) => api.patch(endpoints.quotes.nextAction(id), data),

  /**
   * Marquer la prochaine action comme faite : la demande la perd, mais une
   * tâche complétée en garde la trace (renvoyée dans `completed_task_id`).
   * À ne pas confondre avec `updateNextAction(id, { nextActionDate: null })`,
   * qui efface sans rien laisser.
   */
  completeNextAction: (id) => api.post(endpoints.quotes.completeNextAction(id), {}),

  getTasksToday: (userId) => {
    const params = userId ? `?userId=${userId}` : ''
    return api.get(`${endpoints.quotes.tasksToday()}${params}`)
  },

  getStatsSummary: () => api.get(endpoints.quotes.stats.summary()),

  getStatsCharts: (period) => {
    const params = period ? `?period=${period}` : ''
    return api.get(`${endpoints.quotes.stats.charts()}${params}`)
  },

  getStatusTransitions: () => api.get(endpoints.quotes.stats.statusTransitions()),

  getStatusTransitionTime: (fromStatus, toStatus) => api.get(endpoints.quotes.stats.statusTransitionTime(fromStatus, toStatus)),

  exportCSV: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quotes.export.csv()}?${queryString}` : endpoints.quotes.export.csv()
    return api.get(url)
  },

  exportExcel: (params = {}) => {
    const queryString = new URLSearchParams(params).toString()
    const url = queryString ? `${endpoints.quotes.export.excel()}?${queryString}` : endpoints.quotes.export.excel()
    return api.get(url)
  },

  exportStatsPDF: () => api.get(endpoints.quotes.export.statsPDF())
}
